import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services';
import { checkTranslation, getAppletsAndhubsFromFramesList, imageAddress, translate } from '../../utils/useful';
import FixedView from '../FixedView'

export default class SelectApplet_ extends Component {

    state = {
        fixed: false,
        list: [],
        currentApplet: null,
        currentAppletName: '',
    }

    componentDidMount() {
        let data = {}
        data.frameType = this.props.type
        let list = this.state.list

        HttpServices.request('getMyAppletsType', data, (fetchResult, fetchError) => {

            if (fetchError) {
                return
            }
            let frames = fetchResult.frames ?? []


            getAppletsAndhubsFromFramesList(frames, (hubs, applets) => {


                // fetchResult.info.map((element, index) => {
                //     if (element.applet.default) {
                //         element.applet.name = element.appletHub?.fullname
                //     }
                // })
                // list = fetchResult.info
                // list.unshift({ name: translate('All') })
                // let all = translate("All")
                this.setState({ frames, hubs, applets, currentAppletName: null })

            })
        })
        // this.appletView.addEventListener('click', (e) => {
        //     let inside = e.target.closest('')
        // })
    }

    openAppletView = () => {
        let view = this.state.fixed
        this.setState({ fixed: true }, () => {
            // if (!this.state.fixed) {
            this.appletView.showView()
            // }
        })
    };

    onHide = () => {
        this.setState({ fixed: false }, () => {
        })
    };

    changeApplet = (prop, type) => {
        let currentSelected = this.state.currentSelected
        let currentSelectedName = this.state.currentSelectedName
        if (!prop?.applet) {
            currentSelected = null
            currentSelectedName = prop.name
        }
        else {
            currentSelected = { _id: prop._id, appletHub: prop.hub, settings: prop.settings, type }
            // currentSelectedName = prop.applet.name
        }
        this.setState({ currentSelected, currentSelectedName, fixed: false }, () => {
            this.appletView.hideView()
            this.props.setData('currentSelected', currentSelected)
            return currentSelected
        })
    }

    render() {
        let { frames } = this.state

        return (
            <div >
                <button ref={(el) => (this.currentNode = el)} className={'flexcb w-100 px-2 py-1 position-relative transition-1 ' + (this.state.fixed ? "select-applet-border brt-10" : "blue-box-border-h br-10")} style={{ backgroundColor: "#fff" }} onClick={() => this.openAppletView()}>
                    <p style={{ color: "#555" }}>{this.state.currentSelected ? checkTranslation(this.state.currentSelected?.name) : 'All'}</p>
                    <img className={' transition-1 ' + (this.state.fixed ? "" : " rotate-180 ")} src='/assets/icons/arrow-up-blue.svg' />
                    <div className='br-10 position-absolute' style={{ backgroundColor: "#fff", width: "max-content", top: -10, left: 20 }}>
                        <p className='font-size-10 weight-300 px-2 py-1' style={{ color: "#777" }} >{translate('Current frame')}</p>
                    </div>
                </button>
                <FixedView onHide={this.onHide} ref={el => this.appletView = el} nodeRef={this.currentNode} isOpen={this.state.fixed} showFocus={true} zIndex={99} topOffset={-1} xOffset={-10}>
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <div className='p-1 sc-gray2' style={{ maxHeight: '250px', overflowY: 'scroll' }}>


                            <button className='flexc py-2 w-100 bb-gray' onClick={() => this.changeApplet(null)}>
                                <div className='mrd-2 flexcc'>
                                    <img className='br-50' width={20} height={20} src='/assets/icons/messenger/infinity.svg' />

                                </div>
                                <p className='text-small text-semibold'>{translate("All")}</p>
                            </button>


                            {frames?.map((prop, index) => {
                                let name = prop?.name ? prop?.name : prop.name
                                return (
                                    <button className='flexc py-2 w-100 bb-gray' onClick={() => this.changeApplet(prop)}>
                                        <div className='mrd-2 flexcc'>
                                            <img className='br-50' width={20} height={20} src={imageAddress(prop.image, "applet")} alt='' />
                                        </div>
                                        <p className='text-small text-semibold'>{prop?.name ? checkTranslation(prop?.name) : prop.name}</p>
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}